import React, { useState, useEffect, useCallback } from "react";
import { SimpleGrid, Button } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import Loading from "../../Component/Loading/loading";
import apiService from "../../Method/Advanced_Settings/Branch_Service";
import { ThemeProvider } from "@mui/material/styles";
import MUIDataTable from "mui-datatables";
import theme from "../../assets/Table/TableTheme";
import options from "../../assets/Table/TableOption_NoPrint";
import { IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import Swal from "sweetalert2";
import { t } from "i18next";

import InputText from "../../Component/Input/Input";
import { EditIcon } from "@chakra-ui/icons";

const columns = (handleDelete, handleEdit) => [
  {
    name: "_id",
    label: "ID",
    options: { filter: false, sort: false, display: false, viewColumns: false },
  },

  {
    name: "USER_NAME",
    label: t("USER_NAME"),
    options: { filter: false, sort: false },
  },
  {
    name: "PASSWORD",
    label: t("PASSWORD"),
    options: { filter: false, sort: false },
  },
  {
    name: "BRANCH_NAME",
    label: t("Branch_Name"),
    options: { filter: false, sort: false },
  },
  {
    name: "BRANCH",
    label: t("Branch_Code"),
    options: { filter: false, sort: false },
  },


  {
    name: "",
    label: t("Edit"),
    options: {
      filter: false,
      sort: false,
      viewColumns: false,
      customBodyRender: (value, tableMeta) => (
        <IconButton
          onClick={() => handleEdit(tableMeta)}
          className="TableIcon"
        >
          <EditIcon />
        </IconButton>
      ),
    },
  },
  {
    name: "",
    label: t("Delete"),
    options: {
      filter: false,
      sort: false,
      viewColumns: false,
      customBodyRender: (value, tableMeta) => (
        <IconButton
          onClick={() => handleDelete(tableMeta)}
          className="TableIcon"
        >
          <DeleteIcon />
        </IconButton>
      ),
    },
  },
];

function App() {
  const { t } = useTranslation();

  const [PASSWORD, setPASSWORD] = useState("");
  const [ID, setID] = useState("");
  const [Edit, isEdit] = useState(false);
  const [USER_NAME, setUSER_NAME] = useState("");
  const [branchName, setBranch] = useState("");
  const [branchcode, setBranchCode] = useState("");
  const [data, setData] = useState([]);
  const [isLoading, setLoading] = useState(true);

  const [error, setError] = useState(null);

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const { success, data, error } = await apiService.get();

      if (success) {
        setData(data);
      } else {
        setError(error.message);
      }
    } catch (err) {
      setError(err.message);
    } finally {
    } setLoading(false);

  }, []);
  useEffect(() => {
    fetchData();
  }, [fetchData]);
  const handleClear = () => {
    setUSER_NAME("");
    setPASSWORD("");
    setBranch("");
    setBranchCode("");
    setError("");
    setID("");
    isEdit(false);
  };

  const handleEdit = useCallback(
    async (data) => {
      setID(data.rowData[0]);
      isEdit(true);
      setUSER_NAME(data.rowData[1]);
      setPASSWORD(data.rowData[2]);
      setBranch(data.rowData[3]);
      setBranchCode(data.rowData[4]);

    },
    []
  );
  const handleDelete = useCallback(
    async (data) => {
      const id = data.rowData[0];
      const branchName = data.rowData[1];
      await Swal.fire({
        icon: "error",
        title: `${t("Confirm_msg")} ${branchName}`,
        focusConfirm: false,
        showCancelButton: true,
        customClass: {
          container: "alertContainer",
          popup: "alertPopUp",
          title: "title",
          confirmButton: "confirm",
          cancelButton: "cancel",
        },
        preConfirm: async () => {
          const { success, error } = await apiService.delete(id);
          if (success) {
            setData((prevData) => prevData.filter((item) => item._id !== id));
            handleClear();
          } else {
            setError(error.message || "An error occurred while deleting data.");
          }
        },
      });
    },
    [t]
  );

  const handleInsert = async (e) => {
    e.preventDefault();
    var data = {}
    var link = ""
    if (Edit) {
      link = "UPDATE_SUB_ACCOUNT_USERNAME_PASSWORD";

      data =
      {
        "SUB_ID": ID,
        "MAIN_ACCOUNT_ID": localStorage.getItem("UserID"),
        "USER_NAME": USER_NAME.trim().toUpperCase(),
        "PASSWORD": PASSWORD.trim().toUpperCase(),
      }


    } else {
      link = "INSERT_SUB_ACCOUNT";

      data = {
        "BRANCH": branchcode,
        "BRANCH_NAME": branchName,
        "USER_NAME": USER_NAME.trim().toUpperCase(),
        "PASSWORD": PASSWORD.trim().toUpperCase(),
        "MAIN_ACCOUNT_ID": localStorage.getItem("UserID"),
        "PERMISSION": {}
      }
    }
    const { success, error } = await apiService.post(data, link);
    if (success) {
      if (!Edit) {
        setData((prevData) => [...prevData, { ...data, id: success.id }]);
      } else {
        setData((prevData) =>
          prevData.map((item) =>
            item._id === ID ? { ...item, USER_NAME, PASSWORD } : item
          )
        );
      }
      handleClear();
    } else {
      setError(error.response.data.message);
    }

  };

  return (
    <ThemeProvider theme={theme}>
      <form onSubmit={handleInsert}>
        <SimpleGrid className="Total_Header_Without_Bg"
          gap={5}
          columns={{ base: 1, md: 2, lg: 3, "2xl": 4 }}
          style={{ marginInline: "5px" }}
          columnGap={50}
        >
          <InputText
            type="text"
            required
            value={USER_NAME}
            labels={t("USER_NAME")}
            onChange={(value) => setUSER_NAME(value)}
          />
          <InputText
            type="text"
            required
            value={PASSWORD}
            labels={t("PASSWORD")}
            onChange={(value) => setPASSWORD(value)}
          />



          {!Edit && (<InputText
            type="text"
            required
            value={branchName}
            labels={t("Branch_Name")}
            onChange={(value) => setBranch(value)}
          />)}
          {!Edit && (<InputText
            type="text"
            required
            value={branchcode}
            labels={t("Branch_Code")}
            onChange={(value) => setBranchCode(value)}
          />)}


          <Button type="submit" className="login-btn">
            {t("save")}
          </Button>
        </SimpleGrid>
      </form>

      {error && <p className="error-message">{error}</p>}
      {isLoading && <Loading />}
      <div>
        {!isLoading && (
          <div style={{ width: "100%", overflowX: "auto", marginTop: "10px" }}>
            <MUIDataTable
              title={""}
              data={data}
              columns={columns(handleDelete, handleEdit)}
              options={options}
            />
          </div>
        )}
      </div>
    </ThemeProvider>
  );
}

export default App;
